import { render, staticRenderFns } from "./OrganizationShow.vue?vue&type=template&id=8e7ffa6a"
import script from "./OrganizationShow.vue?vue&type=script&lang=js"
export * from "./OrganizationShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports